var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nrk"},[_c('Details',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }